import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertifyService } from '../../services/alertify.service';
import { DatePipe } from '@angular/common';
import { EditorChangeContent, EditorChangeSelection } from 'ngx-quill'
import { SystemService } from '../../services/system.service';
import { DocumentTypeService } from '../../services/documenttype.service';
import { TypeService } from '../../services/type.services';
import { FAQService } from '../../services/faq.service';
import { Documenttype } from '../documenttype/documenttype';
import { FAQ } from '../../model/faq';

@Component({
    selector: 'app-faq-list',
    templateUrl: './faq-list.component.html',
    styleUrls: ['./faq-list.component.scss'],
    providers: [DatePipe],
})
export class faqListComponent implements OnInit {
    faqform: FormGroup;
    faq: FAQ; public allowedExtensions: Array<string> = ["png", "jpg", "jpeg", "gif", "bmp"];
    userSubmitted: boolean;
    file: any;
    fileExtension: any;
    filepostedOn = new Date().toString().split("+")[0].split(':').join('_');
    imageUrl: string | ArrayBuffer = "https://www.adc-awards.archi/images/joomlart/demo/default.jpg"
    @ViewChild('editor') editor;
    fileName: any;
    documentTypelist: any;
    typelist: any;
    galleryItems: any;
    isLoading = false;

    @Input() documenttype: Documenttype[] = [];
    @Output() editDocumenttype = new EventEmitter<Documenttype>();
    @Output() deleteDocumenttype = new EventEmitter<number>();
    apiPath: any;

    constructor(private fb: FormBuilder,
        private alertify: AlertifyService,
        private router: Router,
        private typeService: TypeService,
        private fAQService: FAQService,
        private documentTypeService: DocumentTypeService,
        public service: SystemService) { }

    ngOnInit() {
        // this.loadGallery();
        this.apiPath = this.service.Settings.Base_API_URL;
        this.refreshGridData();
    }

    private gridApi: any;
    private gridColumnApi: any;

    columnDefs = [
        { headerName: 'Id', field: 'faqId', sortable: true, filter: true, width: 20 },
        { headerName: 'Questions', field: 'faqQuestions', sortable: true, filter: true, editable: true, width: 200 },
        { headerName: 'Answers', field: 'faqAnswer', sortable: true, filter: true, editable: true, width: 200 },
        {
            headerName: 'Actions',
            cellRenderer: this.actionsCellRenderer.bind(this),
            sortable: false,
            filter: false,
            width: 120
        },

    ];

    defaultColDef = {
        flex: 1,
        minWidth: 100,
        resizable: true
    };

    rowData: any;
   

    refreshGridData(): void {
        this.loadGallery();
        if (this.rowData) {
            this.gridApi.setRowData(this.rowData); // Refresh the grid with the updated data
        }
    }

    onGridReady(params: any) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    imageCellRenderer(params: any) {
        return `<img src="${this.apiPath + '/Documents/appImages/' + params.value}" alt="Image" style="max-width: 50px; max-height: 50px;">`;
    }
    actionsCellRenderer(params: any) {
        // const addButton = document.createElement('button');
        // addButton.innerHTML = 'Add';
        // addButton.classList.add('Actions-btn'); // Apply the CSS class
        // addButton.addEventListener('click', () => this.addRow());

        const editButton = document.createElement('button');
        editButton.innerHTML = 'Edit';
        editButton.classList.add('Actions-btn'); // Apply the CSS class
        editButton.addEventListener('click', () => this.editRow(params.data));

        const deleteButton = document.createElement('button');
        deleteButton.innerHTML = 'Delete';
        deleteButton.classList.add('Actions-btn'); // Apply the CSS class
        deleteButton.addEventListener('click', () => this.deleteRow(params.data));

        const wrapper = document.createElement('div');
        wrapper.appendChild(editButton);
        //wrapper.appendChild(addButton);
        wrapper.appendChild(deleteButton);

        return wrapper;
    }

    addRow() {
        this.router.navigate(['/faqAdd']);
    }
    editRow(rowData: any) {
        // Implement your edit logic here
        console.log('Edit row:', rowData);
        let id = rowData.faqId;
        console.log('idpassingtoedit', id);
        this.router.navigate(['/faqEdit', id]);

    }
    deleteRow(rowData: any) {

        console.log(rowData);
        const userConfirmed = confirm('Are you sure you want to delete?');
        if (userConfirmed) {
            let res = this.fAQService.deletefaq(rowData.faqId);
            if (res) {
                console.log(JSON.stringify(res));
                this.refreshGridData();
                this.loadGallery();
                this.alertify.success("Deleted Successfully");
            }
        } else {
            console.log('Deletion canceled.');
        }

    }

    loadGallery() {
        this.service.App.ShowLoader = true;
        this.fAQService.getAllfaq().then(gallerylist => {
            console.log(gallerylist, "gallerylist")
            this.rowData = gallerylist;
        });
        this.service.App.ShowLoader = false;

    }

    addGallery() {
        this.router.navigate(['/faqAdd']);
    }


}

